export default "__VITE_ASSET__0afc3e06__"